module.exports = __webpack_public_path__ + "fonts/f4048e1.otf";